/**
 * GAME VERSION — single source of truth, shown on the menu, HUD and debug overlay.
 * Bump on EVERY push with `npm run bump -- patch|minor|major` (updates this file
 * and package.json together). Rule: patch = tuning/fixes, minor = new feature or
 * content, major = save-schema or gameplay-rule change.
 */
export const GAME_VERSION = '0.41.0';
